import { connect } from 'react-redux'
import Facets from 'components/search/Facets'
import { setFacetsPaginationMode } from 'redux/actions'

const mapStateToProps = (state) => ({
  searchType: state.search.searchType,
  flavour: state.layout.flavour,
  response: state.search.response
})

const mapDispatchToProps = dispatch => ({
  setFacetsPaginationMode: paginationMode => dispatch(setFacetsPaginationMode(paginationMode))
})

export default connect(mapStateToProps, mapDispatchToProps)(Facets)
